var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 10.6667L18.3333 10.6667M6.66663 16.5H13.3333M5.66663 14H14.3333C15.7334 14 16.4335 14 16.9683 13.7275C17.4387 13.4878 17.8211 13.1054 18.0608 12.635C18.3333 12.1002 18.3333 11.4001 18.3333 10V5.5C18.3333 4.09987 18.3333 3.3998 18.0608 2.86502C17.8211 2.39462 17.4387 2.01217 16.9683 1.77248C16.4335 1.5 15.7334 1.5 14.3333 1.5H5.66663C4.26649 1.5 3.56643 1.5 3.03165 1.77248C2.56124 2.01217 2.17879 2.39462 1.93911 2.86502C1.66663 3.3998 1.66663 4.09987 1.66663 5.5V10C1.66663 11.4001 1.66663 12.1002 1.93911 12.635C2.17879 13.1054 2.56124 13.4878 3.03165 13.7275C3.56643 14 4.26649 14 5.66663 14Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/technology.9681227733382641030bb4c0a0f8c674.svg";
export { ForwardRef as ReactComponent };